import { render } from "./markdownDashboard.vue?vue&type=template&id=03832f8f&scoped=true"
import script from "./markdownDashboard.vue?vue&type=script&lang=js"
export * from "./markdownDashboard.vue?vue&type=script&lang=js"

import "./markdownDashboard.vue?vue&type=style&index=0&id=03832f8f&media=screen&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03832f8f"]])

export default __exports__